/* eslint-disable space-before-function-paren */
import axios from 'axios';
import { Toast } from 'vant';
// import { Base64 } from 'js-base64'
import { getToken } from '@/utils/storage';
import router from '../router';
axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
/**
 * 请求拦截
 */
axios.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['token'] = getToken();
    }
    config.headers['clientType'] = 'practice';
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
/**
 * 响应拦截器
 */
axios.interceptors.response.use(
  res => {
    const errCode = res.data.errorCode;
    if (errCode === '0') {
      return res.data;
    } else {
      // 创建考题时,已有考题的错误吗单独处理
      if (errCode === '100401') {
        if (router.to.path === '/login' || router.to.path === '/reg') {
          return res.data;
        }
        setTimeout(() => {
          router.push('/login');
        }, 1000);
      }
      if (errCode !== '100402') {
        Toast(res.data.message);
      }
      return res.data;
    }
  },
  error => {
    if (error.toString().indexOf('timeout') !== -1) {
      Toast('newwork timeout!');
    } else {
      const errorStatus = error.response.status;
      const errData = error.response.data;
      switch (errorStatus) {
        case 401:
          break;
        case 403:
          Toast(errData.message);
          break;
        case 422:
          Toast(errData.message);
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
